import { Typography } from '@mui/material';
import styled from 'styled-components';

export const Title = styled(Typography).attrs({
  variant: 'h6',
})`
  font-size: 15px;
  font-weight: bold;
  color: #000000;
  line-height: 1;
`;
